// LanguageContext.js

import { createContext, useState } from 'react';
import English from './language/en';
import Spanish from './language/sp';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(English); // Initial language is English

  const handleLanguageChange = (selectedLanguage) => {
    // setLanguage(prevLanguage => prevLanguage === Spanish ? English : Spanish);
    
    if(selectedLanguage == 'sp'){
        setLanguage(Spanish);
    }else{
        setLanguage(English);
    }

  };

  return (
    <LanguageContext.Provider value={{ language, handleLanguageChange }}>
      {children}
    </LanguageContext.Provider>
  );
};
